import React from 'react';
import { useTranslation } from 'react-i18next';

const TitleFieldRead = ({ titleValue }) => {
  const { t: translator } = useTranslation();
  return (
    <div
      className="create-hearing-form-field"
      aria-label={translator('ariaLabel.titleFieldRead')}
    >
      <div className="hearing-resume">
        <h2 className="h2-style">{translator('hearingProperties.title')}</h2>
        <p> {titleValue || '-'} </p>
      </div>
    </div>
  );
};

export { TitleFieldRead };
